export default __webpack_public_path__ + "55613ae38e45105adc9ab2daf471713d.png";